module.exports = __webpack_public_path__ + "img/loc_illu@2x.a96a2962.png";